import { Cycle } from './Cycle';

export enum SegmentType {
  All = 'all',
}

export enum SegmentFilterType {
  All = 'all',
  Custom = 'custom',
  Testing = 'testing',
  BulkRetargeting = 'bulkRetargeting',
}

export enum SegmentFilterOptions {
  BasketAbandonment = 'cartAbandonment',
  BrowseAbandonment = 'browseAbandonment',
  Purchase = 'purchase',
  PurchaseCheck = 'purchaseExclusion',
}

export interface SegmentFilter {
  id: string;
  type: SegmentFilterType;
  include?: boolean;
  value: string;
  options: string[];
  comparison: string;
  channel?: string;
}

export interface PercentageSplit {
  id: string;
  name: string;
  percentage: number;
  cycles: Cycle[];
  isDefault?: boolean;
}

export interface Segment<Has2DFilter extends boolean = false> {
  id: string;
  name: string;
  type: SegmentType;
  segmentFilters: Has2DFilter extends true ? SegmentFilter[][] : SegmentFilter[];
  percentageSplits: PercentageSplit[];
  splitTestName?: string;
  splitTestId?: string;
}
